<!-- SMT微信公众号弹框 -->
<template>
  <el-dialog
    width="618px"
    top="15%"
    title="提示"
    append-to-body
    :visible="isShow"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="patch-dialog"
    @close="handleClose"
  >
      <el-form class="dialog-content" size="small" label-width="120px">
        <div class="title">
          系统检测到关联的PCB订单生产数量修改为{{pcsNumber}}片，原录入的SMT生产套数{{patchNumber}}套，请修改SMT生产套数
        </div>
        <div class="content">
           <number
              key = "1"
              label ="SMT生产套数"
              ref="number" 
              type = "modal"
              :isShowNumberType = "allPatchFlag"
              :units = "pcbParams.units"
              :customPcbBan = "smtParams.custom_pcb_ban"
              :number.sync="smtParams.number" 
              :number_type.sync="smtParams.number_type" 
              :pcbNumber="pcbNumber"
            />
        </div>
     
      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button size="medium" class="submit-btn" @click="handleConfirm">继续提交</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { SMT_DEFAULT_FORM,FR4_DEFAULT_FORM } from '@@/utils/defaultForm'
import number from "../fields/number.vue";
import { pcsNumForSet } from '@@/utils/pcbParamsFormat'
export default {
  components: {
    number
  },
  inject: {
    smtParams: { default: { ...SMT_DEFAULT_FORM } },
    pcbParams: { default: { ...FR4_DEFAULT_FORM } },
  },
  props: {
    allPatchFlag:{
      type: Boolean,
      default: false
    },
    pcbNumber: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      info: null,
      patchNumber:0,
      pcsNumber:0,
      isShow: false,
    }
  },
  methods: {
    open(result) {
      this.pcsNumber = pcsNumForSet(result)
      this.patchNumber = result.number
      this.info = result
      this.isShow = true
    },
    handleClose() {
      this.isShow = false
    },
    handleConfirm(){
      if(+this.smtParams.number_type===0&&this.smtParams.number>this.pcbNumber){
        return
      }
      this.handleClose()
      this.$emit('confirm', this.info)
    }
  },
}
</script>

<style lang="scss" scoped>
.patch-dialog {
  ::v-deep .el-dialog__body {
    padding: 30px 24px;
    padding-top:0px;
  }
}
.content{
  margin-top:15px;
}
.title{
  font-size: 13px;
  color:#666;
}
.submit-btn {
  background-color: #15a675;
  border-color: #15a675;
  color: #fff;

  &:hover {
    background-color: #128a63;
    border-color: #128a63;
  }

  &:focus {
    background-color: #15a675;
    border-color: #15a675;
  }
}
</style>
